<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      rowKey="customSubjectMerchantId"
      :itemNames="['subjectCustTitle']"
      :columns="getColumns()"
      :col="3"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="subjectCustTitle" label="专题名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.name" placeholder="请输入"></a-input>
      </a-form-item>
      <div slot="action" slot-scope="rowItem">
        <a @click="editProject(rowItem.record.customSubjectMerchantId,rowItem.record.templateId)">修改</a>
        <a-divider type="vertical"></a-divider>
        <a @click="lookH5SpecialUrl(rowItem.record.customSubjectMerchantId)">查看链接</a>
      </div>
    </search-page-view>

    <a-modal title="复制链接" :width="500" v-model="visibleLink" @cancel="visibleLink=false" :destroyOnClose='true'
             :footer="null">
      <a-textarea v-model="urlLink" :autoSize="{ minRows: 3, maxRows: 5 }"/>
      <a-button v-clipboard:copy="urlLink" v-clipboard:success="onCopy"
                v-clipboard:error="onError" style="margin-top:20px" type="primary">复制
      </a-button>
    </a-modal>
  </a-card>
</template>

<script>
import searchForm from '../../../../utils/mixins/searchFormMixins'
import formMixin from '../../../../utils/mixins/formMixins'
import CustomizedMixins from './CustomizedMixins'

export default {
  name: 'CustomizedList',
  components: {},
  mixins: [searchForm, formMixin, CustomizedMixins],
  data() {
    return {
      queryParams: {},
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      loadPromise: params => this.getListPromise(params),
      visible: false,
      listData: [], // '投放设置数据'
      imgIndex: '', // '获取 点击上传图片按钮的键值'
      fileList: [],
      visibleLink: false,
      urlLink: '',
      searchItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      }
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG',
      [{ name: 'StyleService', title: '我的专题' },
        { name: 'ServiceThemeTemplate', title: '专题模板' }
      ])
    this.queryParams.merchantId = this.$store.getters.userInfo.merchantId
    this.queryParams.platformId = this.getPlatformConfig().platformId
  },
  mounted() {

  },
  methods: {
    // 拖拽排序功能
    onDraggable(rowItem) {
      this.getLogUtils().logWithTag('==onDraggable排序==', rowItem)
      let idList = rowItem.dataList.map(item => item.subjectmerchantId)
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        listOrder: {
          idList: idList,
          pageNum: rowItem.pageNo,
          pageSize: rowItem.pageSize
        }
      }
      this.getLogUtils().logWithTag('==onDraggable排序==', params)
      this.getHttpServices().getServerApiService().post('updateSubjectSort', params).then(res => {
        this.$message.success('排序成功')
        this.$refs.pageList.refresh()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onCopy(e) {
      this.$message.success('复制成功')
      this.visibleLink = false
    },
    onError(e) {
      this.$message.error('复制失败')
      this.visibleLink = false
    },
    // '编辑专题'
    editProject(customSubjectMerchantId, templateId) {
      this.$router.push({
        name: 'CustomizedAddThemeTemplate',
        query: {
          customSubjectMerchantId: customSubjectMerchantId,
          templateId: templateId,
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId,
          domainUrl: this.$store.getters.h5DomainUrl
        }
      })
    },
    //预览H5商城路径url
    lookH5SpecialUrl(customSubjectMerchantId) {
      if (customSubjectMerchantId) {
        this.visibleLink = true
        let url = '/other/RailSpecial?p=1_' + this.merchantId + '_' + this.merchantId + '&customSubjectMerchantId=' + customSubjectMerchantId
        this.urlLink = this.$store.getters.h5DomainUrl + url
      } else {
        this.$message.error('预览错误，请联系管理员')
      }
    },
    handleUpOrdown(subjectMerchantId, status) {
      let textStr = status == 1 ? '上架' : '下架'
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        status: status,
        subjectmerchantId: subjectMerchantId
      }
      this.getHttpServices().getServerApiService().post('editSubjectMerchantStatus', params)
        .then(res => {
          this.$message.success(textStr + '成功')
          this.$refs.pageList.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params) {
      return this.getHttpServices().getServerApiService().post('/customSubject/market/getSubjectList', params)
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'customSubjectMerchantId',
          width: '80px'
        },
        {
          title: '专题名称',
          dataIndex: 'name',
          width: '28%'
        },
        {
          title: '使用模板',
          dataIndex: 'templateIntroduction'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getTableColumns() {
      return [
        {
          title: '投放渠道',
          dataIndex: 'channel',
          scopedSlots: { customRender: 'channel' }
        },
        {
          title: '展示位',
          dataIndex: 'position',
          scopedSlots: { customRender: 'position' }
        },
        {
          title: '物料设置',
          dataIndex: 'goodsSet',
          scopedSlots: { customRender: 'goodsSet' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">
</style>